import React from "react";
import { useTranslation } from "react-i18next";
import aboutImg from "../../images/about1.png";

const About = () => {
  const { t, i18n } = useTranslation();

  return (
    <section
      className="mahal-about-main"
      dir={i18n.language === "ar" ? "rtl" : "ltr"}
    >
      <div className="container">
        <div className="row align-items-center justify-content-between">

          {/* LEFT IMAGE */}
          <div className="col-xl-5 col-lg-5 mb-4 mb-lg-0">
            <div className="mahal-about-image">
              <img src={aboutImg} alt="About MAHAL" />
            </div>
          </div>

          {/* RIGHT CONTENT */}
          <div className="col-xl-7 col-lg-7">
            <div className="mahal-about-content mahal-service-content">

              <h2 className="mahal-title23">

                <span className="title3-text">
                  {t("about.title1")}
                </span>

                <div className="title-bottom">
                  <span className="from-text">
                    {t("about.from")}
                  </span>

                  <span className="trusted-text">
                    {t("about.highlight")}
                  </span>
                </div>

              </h2>

              <p className="mahal-desc">
                {t("about.desc")}
              </p>

              <p className="mahal-text">
                {t("about.text")}
              </p>

              <div className="about-feature-grid">

                {/* Feature 1 */}
                <div className="about-feature-card">

                  <div className="about-feature-icon">
                    <svg viewBox="0 0 24 24" fill="none">
                      {/* Paste your first SVG here */}
                      <path d="M12 21V10" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
                      <path d="M12 10C12 6 9 4 6 4C6 8 8 11 12 11"
                        stroke="currentColor"
                        strokeWidth="1.8"
                        strokeLinecap="round"
                        strokeLinejoin="round" />
                      <path d="M12 10C12 6 15 4 18 4C18 8 16 11 12 11"
                        stroke="currentColor"
                        strokeWidth="1.8"
                        strokeLinecap="round"
                        strokeLinejoin="round" />
                    </svg>
                  </div>

                  <div className="about-feature-text">
                    <h5>{t("about.f1")}</h5>
                  </div>

                </div>

                {/* Feature 2 */}
                <div className="about-feature-card">

                  <div className="about-feature-icon">
                    <svg viewBox="0 0 24 24" fill="none">
                      {/* Paste your second SVG here */}
                      <path d="M12 20V9" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
                      <path d="M12 9C9 9 6 6 6 3C9 3 12 6 12 9Z"
                        stroke="currentColor"
                        strokeWidth="1.8" />
                      <path d="M12 13C15 13 18 10 18 7C15 7 12 10 12 13Z"
                        stroke="currentColor"
                        strokeWidth="1.8" />
                    </svg>
                  </div>

                  <div className="about-feature-text">
                    <h5>{t("about.f2")}</h5>
                  </div>

                </div>

                {/* Feature 3 */}
                <div className="about-feature-card">

                  <div className="about-feature-icon">
                    <svg viewBox="0 0 24 24" fill="none">
                      {/* Paste your third SVG here */}
                      <path
                        d="M12 22C16 17.5 19 15 19 10A7 7 0 0 0 5 10C5 15 8 17.5 12 22Z"
                        stroke="currentColor"
                        strokeWidth="1.8"
                      />
                      <circle
                        cx="12"
                        cy="10"
                        r="2.2"
                        stroke="currentColor"
                        strokeWidth="1.8"
                      />
                    </svg>
                  </div>

                  <div className="about-feature-text">
                    <h5>{t("about.f3")}</h5>
                  </div>

                </div>

                {/* Feature 4 */}
                <div className="about-feature-card">

                  <div className="about-feature-icon">
                    <svg viewBox="0 0 24 24" fill="none">
                      {/* Paste your fourth SVG here */}
                      <path
                        d="M12 2L19 5V10C19 15 16 19 12 21C8 19 5 15 5 10V5L12 2Z"
                        stroke="currentColor"
                        strokeWidth="1.8"
                      />
                      <path
                        d="M9 12L11 14L15 10"
                        stroke="currentColor"
                        strokeWidth="1.8"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>

                  <div className="about-feature-text">
                    <h5>{t("about.f4")}</h5>
                  </div>

                </div>

              </div>
              <div className="mahal-btn-group mt-4">
                <a href="/Registration" className="mahal-btn-primary">
                  {t("about.cta1")}
                </a>
                <a href="/contact" className="mahal-btn-secondary">
                  {t("about.cta2")}
                </a>
              </div>

            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default About;